
import { computed, defineComponent, onMounted, reactive, ref, inject } from 'vue';
import { ElMessage, ElMessageBox, ElForm } from 'element-plus'
import dayjs from 'dayjs'
import { forEach, isEmpty, isNumber } from 'lodash-es'
import { useStore } from '../store/index'
import useFilterSearch from '../hooks/useFilterSearch'
type FormInstance = InstanceType<typeof ElForm>
export default defineComponent({
  name: 'User',
  setup() {
    const baseAPIURL = inject('baseAPIURL')
    const store = useStore()
    const dialogVisible = ref(false)
    const editMode = ref('')
    const ruleFormRef = ref<FormInstance>()
    const users = computed(() => store.state.user.users.map(user => {
      user.createdAt = dayjs(user.createdAt).format('YYYY-MM-DD HH:mm') 
      user.updatedAt = dayjs(user.updatedAt).format('YYYY-MM-DD HH:mm')
      return user
    }))
    const count = computed(() => store.state.user.count)
    const isLoading = computed(() => store.getters.isLoading)
    const { 
      currentPage,
      PAGE_SIZE,
      searchForm,
      searchTriggered,
      checksRef,
      performGetList,
      resetValues,
      onSort
    } = useFilterSearch('getUsers', { isValid: false, inviter: false })
    const searchRules = reactive({
      type: [
        {
          required: true,
          message: '请输入搜索类型',
          trigger: 'change',
        },
      ],
      value: [
        {
          required: true,
          message: '请输入搜索值',
          trigger: 'blur',
        },        
      ]
    })
    const formData = ref({
      email: '',
      userName: '',
      nickName: '',
      password: '',
      avatar: '',
      type: '',
      role: '',
      balance: 0,
      token: 0,
      range: [] as Date[]
    })
    const triggerEdit = (index: number) => {
      dialogVisible.value = true
      const password = schema.anyOf[0].properties.password as any
      password["ui:hidden"] = true
      const { _id, email, userName, nickName, avatar, type, role, valiFrom, valiTo, balance, token } = users.value[index]
      editMode.value = _id
      
      formData.value = {
        email,
        password: '',
        userName,
        nickName,
        avatar,
        type,
        role,
        balance,
        token,
        ...( (valiFrom && valiTo) ? { range: [valiFrom, valiTo] } : { range: [] }  )
      }
      // schema.properties.coverImage.default = coverImage
    }
    const schema = reactive({
      type: 'object',
      required: [
        'role'
      ],
      "anyOfSelect": {
        "ui:widget": "RadioWidget",
        "ui:title": "选择账户类型",
      },
      "anyOf": [
        {
          "ui:showTitle": true,
          "title": "邮箱创建",
          "properties": { 
            "type": {
              "ui:hidden": true,
              "type": "string",
              "default": "email",
              "const": "email"
            },
            email: {
              type: 'string',
              title: '邮箱地址',
            },
            password: {
              type: 'string',
              title: '用户密码',
              "ui:hidden": false
            },
            userName: {
              type: 'string',
              title: '用户名称',
            },
            nickName: {
              type: 'string',
              title: '用户昵称',
            },
          }
        },
        {
          "ui:showTitle": true,
          "title": "手机创建",
          "properties": { 
            "type": {
              "ui:hidden": true,
              "type": "string",
              "default": "cellphone",
              "const": "cellphone"
            },
            cellphone: {
              type: 'string',
              title: '手机号码',
            },
          }
        },
        {
          "ui:showTitle": true,
          "title": "Oauth创建",
          "properties": { 
            "type": {
              "ui:hidden": true,
              "type": "string",
              "default": "oauth",
              "const": "oauth"
            },
            email: {
              type: 'string',
              title: 'OauthID',
            },
          }
        }
      ],
      properties: {
        role: {
            title: "用户角色",
            type: "string",
            "enum": [
              "member",
              "admin",
            ],
            "enumNames": [
              "普通用户",
              "管理员",
            ],
            default: 'member'
        },
        "range": {
          "title": "会员开始结束时间",
          "type": "array",
          "format": "date-time",
          "items": {
            "type": "string"
          }
        },
        token: {
            type: 'number',
            title: 'Token 数量'
        },
        balance: {
          type: 'number',
           title: 'Balance 数量'
        },
        avatar:{
          "anyOfSelect": {
              "ui:widget": "RadioWidget",
              "ui:title": "头像图片",
              "ui:options": {}
          },
          anyOf: [
            {
              title: "上传图片",
              type: "string",
              default: "",
              "ui:action": `${baseAPIURL}/api/upload`,
              "ui:with-credentials": true,
              "ui:list-type": "picture",
              "ui:widget": "UploadWidget",
              "ui:btnText": "上传头图"
            }, 
            {
              title: "直接填写URL",
              type: "string",
            }
          ]
        }
      }
    })
    
    const onCreateNew = () => {
      const password = schema.anyOf[0].properties.password as any
      password["ui:hidden"] = false
      formData.value = {
        email: '',
        userName: '',
        nickName: '',
        password: '',
        avatar: '',
        type: 'email',
        role: '',
        token: 5000,
        balance: 0,
        range: []
      }
      dialogVisible.value = true
      editMode.value = ''  
    }
    const onSearch = () => {
      if (!ruleFormRef.value) return
      ruleFormRef.value.validate(async (valid) => {
        // 两种情况，
        if (valid || (searchForm.dateRange && !valid)) {
          if (ruleFormRef.value) {
            ruleFormRef.value.clearValidate('type')
            ruleFormRef.value.clearValidate('value')
          }
          searchTriggered.value = true
          currentPage.value = 1
          await performGetList()
        } else {
          return false
        }
      })
    }
    const resetSearch = () => {
      if (!ruleFormRef.value) return
      searchForm.dateRange = ''
      ruleFormRef.value.resetFields()
      resetValues()
    }
    const onClear = async () => {
      resetSearch()
      await performGetList()
    }
    const toggleDisabled = async (id:string, disabled: boolean) => {
      await store.dispatch('updateUser', { urlParams: { id }, data: { disabled } })
      ElMessage({
        type: 'success',
        message: '更新成功',
        duration: 1000
      })
    }
    const onCancel = () => {
      dialogVisible.value = false
    }
    const formatData = ( editMode: boolean ) => {
      const data: Record<string, any> = {}
      forEach(formData.value, (value, key) => {
        // isEmpty 会排除 number，所以 number 要自己处理一下
        if (!isEmpty(value)) {
          if (key === 'range'  && Array.isArray(value) && value.length === 2) {
            data.valiFrom = new Date(value[0] as any)
            data.valiTo = new Date(value[1] as any)
            // 只有创建模式才需要添加额外的字段，
            // 编辑模式，现在只修改几种值，range/balance/token
          } else if (!editMode) {
            data[key] = value
          }
        }
        // balance and token
        if (isNumber(value)) {
          // balance 设置为 0 的时候不生效，因为默认为零
          if (key === 'balance' && value !== 0) {
            data[key] = value
          } else if (key === 'token') {
            data[key] = value
          }
        }
      })
      return data
    }
    const onSubmit = async () => {
      if (editMode.value === '') {
        const finalData = formatData(false)
        console.log('create', finalData)
        await store.dispatch('createUser', { data: finalData })
        await store.dispatch('getUsers')
        ElMessage({
          type: 'success',
          message: '创建成功',
          duration: 1000
        })
        dialogVisible.value = false
      } else {
        const finalData = formatData(true)
        console.log('edit', finalData)
        await store.dispatch('updateUser', { urlParams: { id: editMode.value }, data: finalData })
        // await store.dispatch('getUsers', { searchParams: { currentPage: 1, pageSize: PAGE_SIZE }})
        ElMessage({
          type: 'success',
          message: '更新成功',
          duration: 1000
        })
        dialogVisible.value = false
      }
    }
    const onPageChange = async () => {
      await performGetList()
    }
    const onDelete = (id: string) => {
      ElMessageBox.confirm('是否要永久删除该用户？特别注意该用户下的简历会受影响！',  '删除用户', {
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await store.dispatch('deleteUser', { urlParams: { id }})
        ElMessage({
          type: 'success',
          message: '删除成功',
          duration: 1000
        })
      }).catch((e) => {
        throw e
      })
    }
    onMounted(async () => {
      await store.dispatch('getUsers', { searchParams: { currentPage: 1, pageSize: PAGE_SIZE }})
    })
    return {
      users,
      schema,
      formData,
      triggerEdit,
      dialogVisible,
      onCancel,
      onSubmit,
      onCreateNew,
      editMode,
      onDelete,
      toggleDisabled,
      count,
      PAGE_SIZE,
      onPageChange,
      searchForm,
      searchRules,
      ruleFormRef,
      onSearch,
      onClear,
      searchTriggered,
      currentPage,
      onSort,
      checksRef,
      isLoading
    }
  }
});
